import { getQueue, logWorkspace, serviceState } from '../..';
import getQueues from '../../getQueues';
import * as Telecom from '@servicetitan/telecom-rtcs-client';

async function handleQueueAgentRemoved(event: Telecom.QueueAgentRemovedEvent) {
  const queue = getQueue(event.queueId);

  logWorkspace('service:queue:agent_removed:' + queue?.name, event);

  if (!queue) {
    serviceState.queues = await getQueues();
    return;
  }

  queue.memberIds = queue.memberIds.filter(
    (memberId) => memberId !== event.agentId,
  );

  return;
}

export default handleQueueAgentRemoved;
